import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { PushApi } from 'api';
import { IPushMessage } from 'types';

function useGet(id: string) {
  return useAuthQuery(getQueryKeys([KEY]).detail(id), () => PushApi.get(id), {
    select: (data) => data.data as IPushMessage,
    enabled: !!id,
  });
}

export default useGet;
